export const rawAdapterExtensions = [
	".3fr",
	".arq",
	".arw",
	".cr2",
	".cr3",
	".crw",
	".dcr",
	".dng",
	".erf",
	".fff",
	".iiq",
	".kdc",
	".mef",
	".mos",
	".nef",
	".nrw",
	".orf",
	".ori",
	".pef",
	".raf",
	".raw",
	".rw2",
	".rwl",
	".sr2",
	".srf",
	".srw",
	".sti",
	".tif",
	".tiff",
]
